const themeColors = {
    colorPrimary: "#002554",
    colorSecondary: "#FFB600",
    colorSuccess: "#008904",
    colorSuccessGreen: "#2D8900",
    colorDanger: "#C63527",
    colorDangerLight: "#fcf3f2",
    colorDisabled: "#9C9C9C",
    colorWarning: "#FF9400",
    colorInfo: "#2060AD",
    colorHeadText: "#2060AD",
    colorBlack: "#000",
    colorWhite: "#fff",
    colorYellow: "#ffb600",
    colorRed: "#C63527",
    colorBackground: "#fff",
    colorMeasureText: "#424B5A",
    colorpriceText: "#c63527",
    colorBackgroundLightGrey: "#F7F9FA",
    colorBackgroundLightGreyNew: "#f2f2f2",
    colorBorderBrands: "#c2d1d9",
    colorBorderSeperator: "#c2d1d9",
    colorBorderNav: "rgba(194, 209, 217, .45)",
    colorBrandsSeeMore: "#535e64",
    colorBackgroundContrast: "#002554",
    colorFooterBackground: "#002554",
    colorFooter: "#f4f6fd",
    colorFooterNew: "#001d42",
    colorGrey: "#CCCCCC",
    colorGreyCancel: "#868686",
    colorToolTip: "#e7f7ff",
    colorAccent: "#2D3435",
    colorLavenderPinocchio: "#E1E1E1",
    colorLink: "#2E64B0",
    colorInputFocus: "#2060AD",
    colorActiveMenuLink: "#005cb9",
    colorMenuHeader: "#f3f4f5",
    colorBorderNew: "#E4E8F0",
    colorBorderCyanBlue: "#C3D4EA",
    colorBorderCyanBlueNew: "#F3F8FE",
    colorButtonHover: "#2060ad",
    colorButtonFocus: "#2060ad",
    colorButtonActive: "#002554",
    colorPrimaryButtonHover: "#FF9400",
    colorPrimaryButtonFocus: "#2060ad",
    colorPrimaryButtonActive: "#AB6300",
    colorGunsmoke: "#828685",
    colorEndeavour: "#005cb9",
    colorBiscay: "#16325C",
    colorSelectBox: "#333F48",
    colorCharcoalGrey: "#333F48",
    colorMidGrey:"#535E64",
    colorNotes:"#E5EEF7",
    colorAlabaster:"#F9FAFF",
    colorLavenderMist:"#e0e7ff",
    colorAddress:"#2E384D",
    colorNeonSilver: "#C6C6C6",
    colorBattleshipGray: "#868686",
    colorSquidInk: "#2E384D",
    colorNavajoWhite: "#FFDEB2",
    colorAntiqueWhite: "#FFEFD9",
    colorPaleAqua: "#C3D4EA",
    colorAliceBlue: "#E5EEF7",
    colorLightPureBlue: "#C2D1D9",
    colorBrightGray: "#ECECEC",
    colorColumbiaBlue: "#CDDBEE",
    colorZappyZabra: "#F0F2F3",
};
const themeFontWeights = {
    fontWeightLight: "300",
    fontWeightRegular: "400",
    fontWeightMedium: "500",
    fontWeightSemiBold: "600",
    fontWeightBold: "700",
    fontWeightExtraBold: "800",
    fontWeightForBold: "bold",
    fontWeightNormal: "normal",
};
const themeFontSizes = {
    size12: ".75rem",
    size13: ".8125rem",
    size14: ".875rem",
    size15: ".9375rem",
    size16: "1rem",
    size17: "1.0625rem",
    size18: "1.125rem",
    size20: "1.25rem",
    size22: "1.375rem",
    size23: "1.4375rem",
    size24: "1.5rem",
    size28: "1.75rem",
    size30: "1.875rem",
    size32: "2rem",
    size36: "2.25rem",
    size40: "2.5rem",
    size44: "2.75rem",
    h1Size: "2.5rem",
    h2Size: "2rem",
    h3Size: "1.75rem",
    h4Size: "1.5rem",
    h5Size: "1.25rem",
    h6Size: "1rem",
};
const themeIndentSizes = {
    indent1: "1px",
    indent3: "3px",
    indent5: "5px",
    indent6: "6px",
    indent8: "8px",
    indent10: "10px",
    indent12: "12px",
    indent16: "16px",
    indent20: "20px",
    indent24: "24px",
    indent23: "23px",
    indent25: "25px",
    indent30: "30px",
};

export default themeColors;
export { themeFontWeights, themeFontSizes, themeIndentSizes };